var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1642_67016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.625C14.0216 2.62502 13.0564 2.85023 12.1791 3.28318C11.3017 3.71613 10.5358 4.3452 9.94058 5.12169C9.34539 5.89817 8.93689 6.80123 8.74673 7.76093C8.55658 8.72063 8.58986 9.71123 8.844 10.656L2.625 16.875L2.625 21.375H7.125V19.125H9.375V16.875H11.625L13.35 15.15C13.8885 15.297 14.442 15.372 15 15.375C16.6908 15.375 18.3123 14.7034 19.5078 13.5078C20.7034 12.3123 21.375 10.6908 21.375 9C21.375 7.30924 20.7034 5.68774 19.5078 4.49219C18.3123 3.29665 16.6908 2.625 15 2.625Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.125 8.625C16.5392 8.625 16.875 8.28921 16.875 7.875C16.875 7.46079 16.5392 7.125 16.125 7.125C15.7108 7.125 15.375 7.46079 15.375 7.875C15.375 8.28921 15.7108 8.625 16.125 8.625Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1642_67016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoles);
export default __webpack_public_path__ + "static/media/Roles.b9412f28641a9c06ce58427b27d189c7.svg";
export { ForwardRef as ReactComponent };